export default __webpack_public_path__ + "static/media/icon.0622954a.svg";